<template>
  <el-row v-loading="place.waiting" v-if="selected">
    <el-col :span="24">
      <el-row class="container-border">
        <el-col :span="24" class="clientAddress">
          <div>
            <el-form class="main-form mini-form" >
              <el-row :gutter="10" style="padding-bottom: 10px;">
                <el-col :span="14">
                  <el-form-item>
                    <span class="label">Buscar dirección</span>
                    <el-popover
                      placement="top"
                      width="330"
                      trigger="click">
                      <div class="info-popover">A veces errores en la comuna, region o<br/>
                        faltas ortográficas afectan la búsqueda del punto.<br/>
                        <span class="focus small">
                        ** Busca la dirección re-escribiendo la información recibida. **
                        </span>
                      </div>
                      <i slot="reference"
                         class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
                    </el-popover>
                    <InputSearchAddress :value="place"
                                        @input="placeChanger"
                                        :disabledForm="switch_on"></InputSearchAddress>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item>
                    <span class="label">Buscar por latitud, longitud</span>
                    <el-popover
                      placement="top"
                      width="330"
                      trigger="click">
                      <div class="info-popover">¿Sabes la locación del punto exacto?<br/>
                        pega la latitud y longitud siguiento el formato<br/>
                        <span class="focus small">
                          ** El formato al pegar es 'lat, lng' **
                        </span>
                      </div>
                      <i slot="reference"
                         class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
                    </el-popover>
                    <InputSearchByPosition :value="place"
                                           @setPosition="setPlaceByLocation">
                    </InputSearchByPosition>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-row>
                  <el-col :span="12">
                    <div>
                      <span class="label">
                        Buscar en otros sitios
                      </span>
                      <el-popover
                        placement="top"
                        width="330"
                        trigger="click">
                        <div class="info-popover">
                          ¿No estás seguro de haber encontrado el punto?<br/>
                          Revisa la dirección en otros buscadores<br/>
                          <span class="focus small">
                              ** Luego puedes pegar la 'LAT,LNG' que obtuviste **
                            </span>
                        </div>
                        <i slot="reference"
                           class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
                      </el-popover>
                      <div class="iconsSitesContainer">
                        <a v-for="(site, index) in sites"
                           :href="site.url"
                           :key="index"
                           target="_blank"
                           class="iconSiteContainer">
                          <img :src="getImgUrl(site.img)" :alt="site.url">
                        </a>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                      <el-form class="submitBtns">
                        <el-tooltip class="item" effect="dark"
                                    content="Confirmar punto no encontrado"
                                    placement="top-end">
                          <el-button class="btn grey btn-right"
                                     @click="confirmModalNotFound">
                            <span class="fa-stack fa-1x">
                              <i class="fas fa-map-marker-alt fa-stack-2x"></i>
                              <i class="fas fa-slash fa-stack-2x gray-slash"></i>
                            </span>
                          </el-button>
                        </el-tooltip>
                        <el-button v-if="different"
                                   class="btn primary btn-right" @click="confirmModal">
                          <!--@click="verifyCommune"> -->
                          Encontrado
                        </el-button>
                      </el-form>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="24">
      <MapByGeo v-model="place"
                ref="mapa"
                :height="'390px'"
                :zoom="zoom"
                :latlng="latlng"
                :draggableMarker="true">
      </MapByGeo>
    </el-col>
    <el-dialog title="Geocodificación" :visible.sync="dialogFormVisible">
       <span>¿Desea confirmar la dirección escogida?</span>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loadingSetCommune"
                   @click="dialogFormVisible = false">Cancelar</el-button>
        <el-button :loading="loadingSetCommune"
                   type="primary" @click="handleSubmit">Confirmar</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Confirmación no encontrado" :visible.sync="modalNotFound">
      <span>¿Desea confirmar que no encontro dirección para el punto seleccionado?</span>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loadingSetCommune"
                   @click="modalNotFound = false">Cancelar</el-button>
        <el-button :loading="loadingSetCommune"
                   type="primary" @click="changeAddressNotFound">Confirmar</el-button>
      </span>
    </el-dialog>
  </el-row>
  <el-row v-else>
  </el-row>
</template>

<script>
import { tenantSites } from '@/mixins/tenants';
import { decodeRSA } from '../../../mixins/function';
import InputSearchAddress from '../maps/InputSearchAddress.vue';
import InputSearchByPosition from '../maps/InputSearchByPosition.vue';
import MapByGeo from '../maps/MapByGeo.vue';

export default {
  name: 'GeocodeAssistV3',
  components: {
    InputSearchAddress,
    InputSearchByPosition,
    MapByGeo,
  },
  data() {
    return {
      errors: {
        searchDir: false,
      },
      switch_on: false,
      loadingSetCommune: false,
      modalNotFound: false,
      dialogFormVisible: false,
      latlng: {},
      localityPoints: {},
      zoom: 13,
      place: this.input_place,
      changedCommune: false,
      submitLoading: false,
      newCommune: '',
      initialPoint: {},
      switchCommune: false,
      actualCommune: '',
      position: '',
      sites: [],
    };
  },
  props: {
    input_place: Object,
    socsMode: Boolean,
    selected: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
    capitalizeFirstLetter(string) {
      const low = string.toLocaleString();
      return low.charAt(0).toUpperCase() + low.slice(1).toLowerCase();
    },
  },
  mounted() {
    this.sites = tenantSites();
  },
  computed: {
    different() {
      if (this.place.position.lat !== this.place.loc_lat
        || this.place.position.lng !== this.place.loc_lng) {
        return true;
      }
      return false;
    },
  },
  methods: {
    placeChanger(place) {
      const allowed = ['address',
        'commune',
        'locality',
        'position'];

      const filtered = Object.keys(place)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
          // eslint-disable-next-line no-param-reassign
          obj[key] = place[key];
          return obj;
        }, {});
      Object.assign(this.place, filtered);
    },
    confirmModal() {
      this.dialogFormVisible = true;
    },
    confirmModalNotFound() {
      this.modalNotFound = true;
    },
    changeAddress() {
      this.$emit('changeAddress');
    },
    setPlaceByLocation(position) {
      this.latlng = JSON.parse(JSON.stringify(position));
      this.place = this.$refs.mapa.getLocation();
    },
    changeAddressNotFound() {
      this.modalNotFound = false;
      const params = {
        geo_state_id: 9,
        latitude: this.initialPoint.lat,
        longitude: this.initialPoint.lng,
      };
      this.$emit('updating', this.place.point_id, params);
    },
    getImgUrl(img) {
      const images = require.context('../../../assets/img/', false);
      return images(`./${img}`);
    },
    isFunction(functionToCheck) {
      return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    },
    handleSubmit() {
      this.dialogFormVisible = false;
      const params = {
        geo_state_id: 6,
        latitude: this.place.position.lat,
        longitude: this.place.position.lng,
      };
      this.$emit('updating', this.place.point_id, params);
    },
  },
  created() {
    // TODO: FIXME
    // lat y lng en chile, afecta?
    this.localityPoints.lat = -33.435774;
    this.localityPoints.lng = -70.660690;
    this.initialPoint = JSON.parse(JSON.stringify(this.place.position));
    this.place.address = `${this.place.address}, ${this.place.commune}`;
  },
  watch: {
    input_place(data) {
      this.place = data;
      this.initialPoint = JSON.parse(JSON.stringify(this.place.position));
      this.place.address = `${data.address}, ${data.commune}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .submit-box {
    margin-top: 30px;
  }
  .container-border {
    padding: 15px;
    border: 0;
    box-sizing: border-box;
  }
  .label {
    text-transform: uppercase;
    font-size: 10px;
    color: #606266;
    display: inline-block;
    text-align: left;
    line-height: 12px;
    vertical-align: bottom;
    font-weight: 700;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .switchContainer {
    display: flex;
    justify-content: space-between;
  }
  .tooltipStyle {
    color: #AAD500;
    font-size: 16px;
    vertical-align: bottom;
  }
  .tooltipStyle:hover {
    cursor: pointer;
  }
  .deskContainer {
    width: 100%;
    padding: 10px;
    background: $fb-grey-light-97;
    box-sizing: border-box;
  }
  .clientInfoContainer {
    display: flex;
  }
  .clientIcon {
    height: 71px;
    width: 71px;
    background: white;
    border: 1px solid $fb-grey-light-84;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .fa-user {
      color: $fb-green;
      font-size: 30px;
    }
  }
  .btn-right {
    float: right;
  }
  .clientInfo {
    border: 3px solid #fafafa;
    padding: 10px;
    width: 100%;
    background: white;
  }
  .errorContainer {
    display: flex;
    align-items: center;
    margin: 10px 0 0 20px;
    .fa-exclamation-circle {
      color: $fb-red;
      font-size: 20px;
      margin-right: 5px;
    }
  }
  .notFoundNotification {
    font-size: 12px;
    font-weight: 700;
  }
  .notFoundProposition {
    font-size: 12px;
    font-weight: 300;
    font-style: italic;
  }
  .key-style {
    font-weight: 700;
    font-size: 10px;
    color: $fb-green;
    margin: 0;
    text-align: left;
    text-transform: uppercase;
    margin-bottom: 15px;
  }
  .value-style {
    font-weight: 300;
    font-size: 16px;
    margin: 0;
    text-align: left;

  }
  .cornered {
    color: #a5a5a5;
    position: absolute;
    line-height: 1em;
    //text-shadow: 1px 1px 1px #000;
  }
  .iconsSitesContainer {
    display: flex;
  }
  .iconSiteContainer {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
    }
  }
  .gray-slash {
    color: #a5a5a5;
  }
  .fas.fa-info-circle {
    font-size: 13px;
    margin-left: 5px;
  }
  .el-input {
    margin-top: 1em;
  }
  .info-popover {
    font-size: 12px;
  }
</style>
